import { render } from "./shuiqiu.vue?vue&type=template&id=47e943e6&scoped=true"
import script from "./shuiqiu.vue?vue&type=script&lang=js"
export * from "./shuiqiu.vue?vue&type=script&lang=js"

import "./shuiqiu.vue?vue&type=style&index=0&id=47e943e6&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e943e6"]])

export default __exports__